module.exports = __webpack_public_path__ + "img/some2.e93acb34.jpg";